//region :: Imports ::
import React, {ReactElement} from 'react';
import MComponent from '../Components/Component';
import MButton from '../Components/Controls/Button';
import {MLoginIconName} from '../Icons';
import WithRouterProps from '../WithRouterProps';
import withRouter from '../WithRouter';
import MTemplateOne from '../Templates/TemplateOne';

//endregion

/** */
type Props = WithRouterProps & {};

/** */
class MLogoutPage extends MComponent<Props> {

    /** */
    public constructor(props: Props) {
        super(props);
        this.bindMethods();
    }

    /** */
    private bindMethods(): void {
        this.loginButton_onClick = this.loginButton_onClick.bind(this);
    }

    /** */
    private loginButton_onClick(): void {
        this.props.navigate('/');
    }

    /** */
    public render(): ReactElement {

        return (
            <MTemplateOne title="Logout Sucessful"
                          message="You can now close the tab or click the button below to log in again.">

                <MButton label="Log In"
                         icon={MLoginIconName}
                         disabled={false}
                         onClick={this.loginButton_onClick}/>

            </MTemplateOne>
        );

    }

}

export default withRouter(MLogoutPage);
